import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lift-board-parameter-detail',
  templateUrl: './lift-board-parameter-detail.component.html',
  styleUrls: ['./lift-board-parameter-detail.component.css']
})
export class LiftBoardParameterDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
